// Mock data for the gifting website

export const themeCollections = [
  {
    id: 1,
    name: "Romantic Vibes",
    description: "Soft pinks, roses, and all things love – perfect for date nights, anniversaries, or just because 💕",
    tagline: "Love Language: Gift Edition",
    image: "https://images.unsplash.com/photo-1739912061342-280525e3c20f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxyb21hbnRpYyUyMGdpZnR8ZW58MHx8fHwxNzcxMTg1NDU4fDA&ixlib=rb-4.1.0&q=85",
    color: "#ffc0e3",
    features: ["Pastel pink & cream wrapping", "Heart-shaped gift tags", "Dried roses & ribbons", "Handwritten love notes"]
  },
  {
    id: 2,
    name: "Birthday Bash",
    description: "Confetti, bright colors, and pure celebration energy ✨ Make their day absolutely unforgettable!",
    tagline: "Main Character Energy",
    image: "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxiaXJ0aGRheSUyMGdpZnR8ZW58MHx8fHwxNzcxMTg1NDY3fDA&ixlib=rb-4.1.0&q=85",
    color: "#ffd4e5",
    features: ["Vibrant party colors", "Glitter & confetti details", "Birthday wish cards", "Balloon stickers"]
  },
  {
    id: 3,
    name: "Luxury Moment",
    description: "Black, gold, and extra AF – when you want to say 'you're worth it' in the fanciest way possible ✨",
    tagline: "Bougie & Beautiful",
    image: "https://images.unsplash.com/photo-1592903297149-37fb25202dfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnaWZ0fGVufDB8fHx8MTc3MTE4NTQ4NXww&ixlib=rb-4.1.0&q=85",
    color: "#d4b896",
    features: ["Black & gold wrapping", "Metallic accents", "Premium silk ribbons", "Wax seal stamps"]
  },
  {
    id: 4,
    name: "Soft Aesthetic",
    description: "Dreamy pastels, minimal vibes, and that Pinterest-perfect look that's totally Insta-worthy 🌸",
    tagline: "Soft Girl Era",
    image: "https://images.unsplash.com/photo-1482173074468-5b323335debe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwZ2lmdHxlbnwwfHx8fDE3NzExODU0OTR8MA&ixlib=rb-4.1.0&q=85",
    color: "#e8d5f2",
    features: ["Soft lavender & mint", "Minimalist design", "Natural elements", "Subtle pearl accents"]
  },
  {
    id: 5,
    name: "Festival Feels",
    description: "Holiday magic, warm colors, and that cozy seasonal energy that hits different 🎄✨",
    tagline: "Season's Greetings, Elevated",
    image: "https://images.unsplash.com/photo-1765992314221-178372ba44be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxmZXN0aXZlJTIwZ2lmdHxlbnwwfHx8fDE3NzExODU1MDJ8MA&ixlib=rb-4.1.0&q=85",
    color: "#ffcdd2",
    features: ["Festive color palette", "Seasonal decorations", "Holiday-themed tags", "Pine & cinnamon scents"]
  },
  {
    id: 6,
    name: "Customize Your Own",
    description: "Got a specific vision? Let's bring it to life! Tell us your color scheme, style, and vibe – we'll make it happen 🎨",
    tagline: "Your Vision, Our Magic",
    image: "https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=800&q=80",
    color: "#c8d5b9",
    isCustom: true,
    features: ["100% personalized design", "Your color palette choice", "Custom decorative elements", "Unique to your style"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya S.",
    message: "literally crying rn 😭 my bestie LOVED her birthday gift! the packaging was chef's kiss 💋 10/10 would recommend",
    rating: 5,
    occasion: "Birthday Surprise"
  },
  {
    id: 2,
    name: "Arjun M.",
    message: "bro this saved my anniversary!! sent them my wishlist links and they made it look SO expensive. gf thought i spent hours on it lmaooo 😂",
    rating: 5,
    occasion: "Anniversary"
  },
  {
    id: 3,
    name: "Diya K.",
    message: "the aesthetic packaging is everything!! 🌸 got the soft aesthetic theme and it's literally Pinterest came to life. obsessed!!",
    rating: 5,
    occasion: "Just Because"
  },
  {
    id: 4,
    name: "Rohan P.",
    message: "these guys GET IT. sent some random products and they turned it into art. my mom cried happy tears 🥺💕",
    rating: 5,
    occasion: "Mother's Day"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "You Shop, We Wrap",
    description: "Send us product links or ship your stuff to us – we'll handle the rest! No stress, just aesthetic vibes ✨",
    icon: "Package"
  },
  {
    id: 2,
    title: "Custom AF",
    description: "Pick from our cute themes OR go full custom with your own ideas. Your vision, our magic hands 💅",
    icon: "Palette"
  },
  {
    id: 3,
    title: "Packaging That Slays",
    description: "Pinterest-worthy, Insta-ready packaging that'll make them say 'omg no way you did this!' (but you did 😏)",
    icon: "Sparkles"
  },
  {
    id: 4,
    title: "We Do The Heavy Lifting",
    description: "From ordering to packing to delivering – we got you covered. You just sit back and take the credit 😎",
    icon: "Gift"
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: "Send Us Your Wishlist",
    description: "Drop those product links (Amazon, Nykaa, anywhere!) OR we'll pickup from your doorstep. Your choice! 🛍️"
  },
  {
    id: 2,
    title: "We Get Everything Ready",
    description: "We order from your links or pickup from you, then receive all products at our studio 📦"
  },
  {
    id: 3,
    title: "Pick Your Vibe",
    description: "Choose from our curated themes (Romantic, Birthday, Luxury, etc.) or go fully custom with your ideas! 🎨"
  },
  {
    id: 4,
    title: "Magic Happens",
    description: "We create gorgeous packaging with all the cute details - wrapping, ribbons, notes, everything! ✨"
  }
];
